import { render, staticRenderFns } from "./Company.vue?vue&type=template&id=2909bdbc&scoped=true"
import script from "./Company.vue?vue&type=script&lang=js"
export * from "./Company.vue?vue&type=script&lang=js"
import style0 from "./Company.vue?vue&type=style&index=0&id=2909bdbc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2909bdbc",
  null
  
)

export default component.exports